import PropTypes from 'prop-types';
import React from 'react';
import styles from './Settings.css';

const SettingsContainer = ({ children }) => {
  return (
    <section
      data-test-id="settings"
      className={styles.settings}
      aria-labelledby="settings-heading"
    >
      <h1 id="settings-heading">Settings</h1>
      {children}
    </section>
  );
};

SettingsContainer.propTypes = {
  children: PropTypes.node
};

export default SettingsContainer;
